import { useState } from 'react';

export interface CaptionStyleDefaults {
  fontFamily: string;
  fontSize: number;
  color: string;
  backgroundColor: string;
  position: 'top' | 'center' | 'bottom';
}

export interface AppConfig {
  debugMode: boolean;
  captionDefaults: CaptionStyleDefaults;
}

const CONFIG_STORAGE_KEY = 'appConfiguration';

const defaultConfig: AppConfig = {
  debugMode: false,
  captionDefaults: {
    fontFamily: 'Arial',
    fontSize: 24,
    color: '#ffffff',
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    position: 'bottom',
  },
};

export function useAppConfig(): [AppConfig, (config: Partial<AppConfig>) => void] {
  const [config, setConfig] = useState<AppConfig>(() => {
    const stored = localStorage.getItem(CONFIG_STORAGE_KEY);
    if (stored) {
      try {
        return { ...defaultConfig, ...JSON.parse(stored) };
      } catch {
        return defaultConfig;
      }
    }
    return defaultConfig;
  });

  const updateConfig = (updates: Partial<AppConfig>) => {
    const newConfig = { ...config, ...updates };
    setConfig(newConfig);
    localStorage.setItem(CONFIG_STORAGE_KEY, JSON.stringify(newConfig));
  };

  return [config, updateConfig];
}


